export default function About() {
  return (
    <section id="about" className="section section--alt">
      <div className="container">
        <div className="about-grid">
          <div className="about-grid__text">
            <span className="section__eyebrow">Who we are</span>
            <h2 className="section__title">
              A full-time crew of DevOps &amp; AI engineers obsessed with delivery.
            </h2>
            <p className="section__lead">
              Dinghy is a senior-only engineering team that designs, builds, and operates
              the platforms modern software companies depend on. We don&rsquo;t freelance on
              the side - this is what we do every day.
            </p>
            <ul className="about-grid__points">
              <li><span className="mdi mdi-check-circle" /> Production-grade cloud &amp; Kubernetes platforms</li>
              <li><span className="mdi mdi-check-circle" /> Automated CI/CD with rollback &amp; safety</li>
              <li><span className="mdi mdi-check-circle" /> AI &amp; agent systems wired into real workflows</li>
              <li><span className="mdi mdi-check-circle" /> FinOps that pay for the engagement</li>
            </ul>
          </div>
          <div className="about-grid__image">
            <img src="assets/imgs/Interview.png" alt="Engineering team" />
          </div>
        </div>

        <div className="about-grid about-grid--reverse">
          <div className="about-grid__image">
            <img src="assets/imgs/Brainstorming.png" alt="Team brainstorming" />
          </div>
          <div className="about-grid__text">
            <span className="section__eyebrow">Why teams pick us</span>
            <h2 className="section__title">
              Senior engineers who&rsquo;ve done this in production.
            </h2>
            <p className="section__lead">
              We blend deep DevOps craft with practical AI engineering - so the
              platforms we ship are reliable, observable, secure, and ready for the next
              wave of intelligent workloads. No hand-offs, no juniors learning on your dime.
            </p>
            <ul className="about-grid__points">
              <li><span className="mdi mdi-check-circle" /> Tight feedback loops with your team</li>
              <li><span className="mdi mdi-check-circle" /> Measurable wins: speed, cost, reliability</li>
              <li><span className="mdi mdi-check-circle" /> Knowledge transfer &amp; documentation included</li>
              <li><span className="mdi mdi-check-circle" /> Long-term partner, not a one-off contractor</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
